import React from 'react';
import { Icon } from './Icon.js';
export const IconEarphoneLeft = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3 8V19H7V11L11 10V3H8C5.23858 3 3 5.23858 3 8Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M15 12V21H21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconEarphoneLeft.js.map